/* @flow */
import React from 'react';

import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

export default function CaseOverviewColumns(): React.Element {
  return (
    <THead>
      <Tr>
        <Th />
        <Th>Created Date</Th>
        <Th style={{ textAlign: `center` }}>Download</Th>
      </Tr>
    </THead>
  );
}
